/**
 * @module app.ApplyHelper
 */
/**
 * Helper for handling DOM interaction and apply.
 */

import olEventsEvent from 'ol/events/Event.js';

/**
 * @constructor
 * @param {angular.Scope} scope
 */
export default class {
  constructor(scope) {
    this.scope_ = scope;
  }

  /**
   * @param {jQuery.Event|ol.events.Event} event
   * @return {boolean}
   */
  isDOMEvent(event) {
    return !!event.originalEvent;
  }

  /**
   * @param {jQuery.Event|ol.events.Event} event
   * @param {function()} fn
   */
  wrapInApplyIfFromDOM(event, fn) {
    if (!this.scope_.$$phase) {
      // Enter Angular cycle
      this.scope_.$apply(function() {
        fn();
      });
    } else {
      fn();
    }
  }

  /**
   * @param {function(T)} fn Function taking a jQuery or ol.events event
   * @param {U=} opt_this
   * @template T,U
   * @return {function((jQuery.Event|ol.events.Event))}
   */
  eventCb(fn, opt_this) {
    const self = this;
    return (
      /** @this {function()} */ function(event) {
        opt_this = opt_this || this;
        console.assert(
          event instanceof jQuery.Event ||
          event instanceof olEventsEvent
        );
        if (!self.scope_.$$phase) {
          self.scope_.$apply(() => {
            fn.call(opt_this, event);
          });
        } else {
          fn.call(opt_this, event);
        }
      }
    );
  }
}
